import { Button, TextField } from "@material-ui/core";
import NumberFormat from "react-number-format";
import Drawer from "../../../../../components/Drawer";
import AddRemoveButtons from "../../../../../components/buttons/AddRemoveButtons";
import CategoryInput from "../Drawer/CategoryInput";
import SizePriceInput from "./SizePriceInput";
import Spinner from "react-bootstrap/esm/Spinner";
import PriceInput from "../../../../../components/inputs/PriceInput";
import SelectType from "../Drawer/SelectType";
import CategoryInputPet from "./CategoryInputPet";
import api from "../../../../../config/api";
import { useState, useEffect } from "react";
import xIcon from "../../../../../assets/img/x-icon-black.svg";

const AddPetDrawer = ({
  erroName,
  erroCategory,
  erroPrice,
  erroMessage,
  loadBtn,
  isPetDrawerOpen,
  setOpenDrawer,
  product,
  handleProductChange,
  handleSubmitFashionProduct,
  subCategories,
  isAddSubCategoryLoading,
  selectedImage,
  selectImage,
  handleAddSubCategory,
  variations,
  getVariations,
  loadBtnPhoto,
  setImageDelete,
  isProductDrawerOpen,
  setProduct,
  petSizes,
  handleSubmitPetProduct,
  types,
  isPetEstablishment,
  setSubCategoriesType,
  subCategoriesType,
  userEstablishment,
}) => {
  const [subCategoriesChange, setSubCategoriesChange] = useState([]);
  const getCategoryByType = async (id) => {
    if (userEstablishment === undefined) return;
    // id = id || product.type._id ? product.type._id : product.type;
    if (!id) return;
    const response = await api
      .get(`/sub-category-type/?type=${id}&establishment=${userEstablishment}`)
      .then((resp) => resp.data);
    setSubCategoriesType(() => response);
    setSubCategoriesChange(() => response);
  };

  const MAX_DISCOUNT_VAL = 100;
  const withValueCap = (inputObj) => {
    const { value } = inputObj;
    if (value <= MAX_DISCOUNT_VAL) return true;
    return false;
  };

  useEffect(() => {
    getCategoryByType(product.type._id);
  }, [product]);

  return (
    <Drawer show={isPetDrawerOpen} onClose={() => setOpenDrawer(false)}>
      <form style={{ maxHeight: "100%" }} onSubmit={handleSubmitPetProduct}>
        <div className="d-flex flex-column">
          <span className="text-cl-black ff-univanova-medium fz-20 mb-4 d-block">Informações gerais</span>
          <TextField
            required
            onChange={(event) => handleProductChange(event)}
            value={product.name}
            name="name"
            label={"Nome do produto"}
            variant={"outlined"}
            className="col-12  fz-16 text-cl-dark-jungle-green ff-univanova mb-4"
          />

          <SelectType
            setSubCategoriesType={setSubCategoriesType}
            product={product}
            handleProductChange={handleProductChange}
            options={types}
            getCategoryByType={getCategoryByType}
          />

          <CategoryInputPet
            {...{
              handleProductChange,
              handleAddSubCategory,
              isAddSubCategoryLoading,
              product,
              subCategoriesType,
              isPetEstablishment,
              subCategoriesChange,
            }}
          />
          <TextField
            disabled={product.type?.name === "product" ? false : true}
            onChange={(event) => handleProductChange(event)}
            value={product.type?.name === "product" ? product.qty : "-"}
            type={product.type?.name === "product" ? "number" : ""}
            name="qty"
            label={"Quantidade (opcional)"}
            variant={"outlined"}
            className="fz-16 text-cl-dark-jungle-green ff-univanova mb-4"
          />
          <PriceInput
            required
            error={erroPrice}
            input={product}
            label="Valor"
            colSize={12}
            onValueChange={(values) => {
              const { floatValue } = values;
              // do something with floatValue
              handleProductChange({
                target: { name: "price", value: floatValue },
              });
            }}
          />
          {/* <TextField
            required
            onChange={(event) => handleProductChange(event)}
            value={product.duration}
            name="duration"
            label={"Duração do procedimento"}
            variant={"outlined"}
            className="col-12 col-lg-6 fz-16 text-cl-dark-jungle-green ff-univanova mb-4"
          /> */}
          {/* <SizePriceInput
            inputs={product.prices}
            setProduct={setProduct}
            petSizes={petSizes}
            handlePetSizePriceChange={handlePetSizePriceChange}
            handleAddPetSizePrice={handleAddPetSizePrice}
            handleRemovePetSizePrice={handleRemovePetSizePrice}
          /> */}
          {/* <NumberFormat
            isAllowed={withValueCap}
            customInput={TextField}
            suffix="% Off"
            onChange={(event) => handleProductChange(event)}
            value={product?.discount}
            name="discount"
            label={"Desconto (opcional)"}
            variant={"outlined"}
            className="col-12  fz-16 text-cl-dark-jungle-green ff-univanova mb-4"
          /> */}
          <TextField
            onChange={(event) => handleProductChange(event)}
            value={product.sku}
            name="sku"
            label={"SKU (opcional)"}
            variant={"outlined"}
            className="fz-16 text-cl-dark-jungle-green ff-univanova mb-4"
          />
          {/* {product.accessory?.length === 0 && (
            <Button className="col-6" type="button" variant="outlined" onClick={() => handleAddAccessory()}>
              Adicionar Acessórios
            </Button>
          )}
          {product?.accessory?.map((accessory, index) => (
            <div className="d-flex col-12 mb-4">
              <TextField
                onChange={(event) => handleAccesoryChange(event, index)}
                value={accessory.name}
                name="acessorio"
                required
                label={"Acessórios do pet"}
                variant={"outlined"}
                className="col-12  fz-16 text-cl-dark-jungle-green ff-univanova "
              />

              <AddRemoveButtons
                isRemoveButtonActive={true}
                isAddButtonActive={index === product.accessory?.length - 1}
                index={index}
                className="ms-3"
                style={{ marginTop: "-4px" }}
                handleAdd={handleAddAccessory}
                handleRemove={handleRemoveAccessory}
              />
            </div>
          ))} */}
          <TextField
            onChange={(event) => handleProductChange(event)}
            value={product.description}
            name="description"
            label={"Descrição (opcional)"}
            variant={"outlined"}
            className="col-12  fz-16 text-cl-dark-jungle-green ff-univanova mb-4"
            multiline
            minRows={4}
          />
          <span className="text-cl-black ff-univanova-medium fz-20 mb-3 d-block">Foto do produto (opcional) </span>
          <form>
            <div className="d-flex flex-wrap m-0 mb-5">
              {product.productPhoto !== undefined ? (
                <>
                  {product.productPhoto.map((item, index) => (
                    <div
                      data-bs-toggle="modal"
                      data-bs-target={"#confirmDeleteImage"}
                      key={index}
                      onClick={() => setImageDelete([index, item._id])}
                      className={`d-flex c-pointer m-2 `}
                    >
                      <img src={item.url} className=" img-fluid" alt="" style={{ height: "137px" }} />
                    </div>
                  ))}
                </>
              ) : (
                <></>
              )}
              {!selectedImage.length ? (
                <></>
              ) : (
                <>
                  {selectedImage?.map((image, index) => (
                    <div
                      data-bs-toggle="modal"
                      data-bs-target={"#confirmDeleteImage"}
                      key={index}
                      onClick={() => setImageDelete([index])}
                      className={`d-flex c-pointer m-2 `}
                    >
                      <img src={image} className=" img-fluid" alt="" style={{ height: "137px" }} />
                    </div>
                  ))}
                </>
              )}
              <label
                htmlFor="file"
                className={` bg-cl-chinese-white d-flex m-2  justify-content-center align-items-center flex-column c-pointer `}
                style={{ height: "137px", width: "187px" }}
              >
                {loadBtnPhoto ? (
                  <Spinner animation="border" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </Spinner>
                ) : (
                  <>
                    <i className="bi bi-plus-circle fz-26 fa-lg text-cl-light-blue-steel"></i>
                    <span className="text-cl-philippine-silver ff-univanova-medium fz-16">Adicionar foto</span>
                  </>
                )}
                <input type="file" id="file" onChange={selectImage} className="d-none" required />
              </label>
            </div>
          </form>
        </div>
        <p style={{ color: "red" }}>{erroMessage}</p>
        <div className="col-12 d-flex justify-content-end">
          <button
            type="button"
            onClick={() => setOpenDrawer(false)}
            className="btn button-white-primary br-6 border-auro-metal me-3 px-4"
          >
            Cancelar
          </button>

          {loadBtn ? (
            <div className="btn br-6 bg-gradient-theme-blue text-white px-4 d-flex align-items-center justify-content-center">
              <Spinner animation="border" role="status" style={{ height: 20, width: 20 }} className="mx-2" />
            </div>
          ) : (
            <button
              disabled={loadBtn}
              type="submit"
              onClick={(e) => handleSubmitPetProduct(e)}
              className="btn br-6 bg-gradient-theme-blue text-white px-4"
            >
              Salvar
            </button>
          )}
        </div>
      </form>
    </Drawer>
  );
};

export default AddPetDrawer;
